import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html'
})
export class NavbarComponent {

  constructor() { }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/core/components/layout/navbar/navbar.component.ts